import { Inject, Injectable } from '@angular/core';

import { WEB_API_URL } from '../utils/common';

@Injectable({ providedIn: 'root' })
export class ApiEndpointService {
  private readonly apiPrefix = 'api/Editors_v2/DndEditor';
  private readonly apiPrefixPages = 'api';
  private readonly apiBasePrefix = 'api/Editors_v2';
  private readonly apiFilePrefix = 'api/FileManager_v2';
  private readonly sectionFavoritesUrl = 'SectionFavorites';
  private readonly featureFlagsUrl = 'FeatureFlags';
  private readonly featureFlagIsEnabled = 'featureFlag/isEnabled';
  private readonly webContentUrl = 'WebContentList';
  private readonly checkSessionUrl = 'CheckSession';
  private readonly loadTemplateUrl = 'load';
  private readonly lockPermissionUrl = 'LockPermissionExists';
  private readonly webPageContentUrl = 'WebPageContent';
  private readonly personalAttributesUrl = 'personalizationAttributes';
  private readonly crmEntitiesUrl = 'CrmEntitiesData';
  private readonly templateItemsUrl = 'TemplateItems';
  private readonly templateUrl = 'DnDTemplate';
  private readonly saveTemplateUrl = 'save';
  private readonly corporateStylesUrl = 'CorporateStyle';
  private readonly validateFreemarkersUrl = 'ValidateFreemarkers';
  private readonly spamTestUrl = 'SpamTest';
  private readonly socialLinksUrl = 'SocialLinks';
  private readonly uploadSocialLinkUrl = 'UploadSocialLinkImage';
  private readonly testEmailUrl = 'SendTestEmail';
  private readonly getBlobData = 'FileUploader/GetBlobData';
  private readonly getStorageQuota = 'FilesList/GetStorageQuota';
  private readonly checkExistingFiles = 'FilesList/CheckExistingFiles';
  private readonly moveFiles = 'FilesList/moveFiles';
  private readonly deleteEntities = 'FilesList/deleteEntities';
  private readonly filesList = 'FilesList';
  private readonly getFilesListUrl = 'FilesList/get';
  private readonly createFromPixie = 'FileUploader/CreateFileFromPixie';
  private readonly uploadFile = 'FileUploader/upload';
  private readonly generateAndSaveVideoThumbnail =
    'FileUploader/generateVideoThumbnail';
  private readonly subDomains = 'SubDomainList';
  private readonly customFonts = 'CustomFonts';
  private readonly loadHtml = 'loadHtml';
  private readonly colorPicker = 'ColorPicker';

  constructor(@Inject(WEB_API_URL) private baseUrl: string) {}

  get SectionFavoritesUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.sectionFavoritesUrl}`;
  }

  get FeatureFlagsUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.featureFlagsUrl}`;
  }

  get FeatureFlagPagesUrl() {
    return `${this.baseUrl}/${this.apiPrefixPages}/${this.featureFlagIsEnabled}`;
  }

  get WebContentUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.webContentUrl}`;
  }

  get CheckSessionUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.checkSessionUrl}`;
  }

  get LoadTemplateUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.loadTemplateUrl}`;
  }

  get SaveTemplateUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.saveTemplateUrl}`;
  }

  get LockPermissionUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.lockPermissionUrl}`;
  }

  get WebPageContentUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.webPageContentUrl}`;
  }

  get PersonalAttributesUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.personalAttributesUrl}`;
  }

  get CrmEntitiesUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.crmEntitiesUrl}`;
  }

  get TemplateItemsUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.templateItemsUrl}`;
  }

  get TemplateUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.templateUrl}`;
  }

  get CorporateStylesUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.corporateStylesUrl}`;
  }

  get ValidateFreemarkersUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.validateFreemarkersUrl}`;
  }

  get SpamTestUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.spamTestUrl}`;
  }

  get SocialLinksUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.socialLinksUrl}`;
  }

  get UploadSocialLinkUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.uploadSocialLinkUrl}`;
  }

  get TestEmailUrl() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.testEmailUrl}`;
  }

  get GetBlobDataUrl() {
    return `${this.baseUrl}/${this.apiFilePrefix}/${this.getBlobData}`;
  }

  get GetStorageQuotaUrl() {
    return `${this.baseUrl}/${this.apiFilePrefix}/${this.getStorageQuota}`;
  }

  get GetFilesListUrl() {
    return `${this.baseUrl}/${this.apiFilePrefix}/${this.getFilesListUrl}`;
  }

  get CheckExistingFilesUrl() {
    return `${this.baseUrl}/${this.apiFilePrefix}/${this.checkExistingFiles}`;
  }

  get MoveFilesUrl() {
    return `${this.baseUrl}/${this.apiFilePrefix}/${this.moveFiles}`;
  }

  get DeleteEntitiesUrl() {
    return `${this.baseUrl}/${this.apiFilePrefix}/${this.deleteEntities}`;
  }

  get FilesListUrl() {
    return `${this.baseUrl}/${this.apiFilePrefix}/${this.filesList}`;
  }

  get CreateFromPixieUrl() {
    return `${this.baseUrl}/${this.apiFilePrefix}/${this.createFromPixie}`;
  }

  get UploadFileUrl() {
    return `${this.baseUrl}/${this.apiFilePrefix}/${this.uploadFile}`;
  }

  get GenerateAndSaveVideoThumbnail() {
    return `${this.baseUrl}/${this.apiFilePrefix}/${this.generateAndSaveVideoThumbnail}`;
  }

  get GetSubDomains() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.subDomains}`;
  }

  get CustomFonts() {
    return `${this.baseUrl}/${this.apiBasePrefix}/${this.customFonts}`;
  }

  get LoadHtml() {
    return `${this.baseUrl}/${this.apiPrefix}/${this.loadHtml}`;
  }

  get ColorPicker() {
    return `${this.baseUrl}/${this.apiBasePrefix}/${this.colorPicker}`;
  }
}
